import { productQuantityOrderedStyles } from "@insite/content-library/Components/ProductQuantityOrdered";
import { formInputStyles, formQuantityInputStyles } from "@store/theme/mixins";
import { css } from "styled-components";

Object.assign(productQuantityOrderedStyles, {
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            width: auto;
            margin: 0 0.6em 0 0 !important;
        `,
        formField: css`
            margin-top: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            width: auto;

            input {
                border-width: 2px;
                ${formInputStyles()}
            }
        `,
        inputSelect: css`
            ${formQuantityInputStyles()}
        `,
    },
});
